import { FolderInput, MoreHorizontal, Pencil, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { cn } from "@/lib/utils";

type Props = {
  canWrite: boolean;
  isEmpty: boolean;
  /** 紧凑样式：目录树行内 */
  compact?: boolean;
  onRename: () => void;
  onMove: () => void;
  onDelete: () => void;
};

/** 文件夹行内「⋯」操作菜单：重命名 / 移动 / 删除 */
export function MaterialsFolderActionsMenu({
  canWrite,
  isEmpty,
  compact = false,
  onRename,
  onMove,
  onDelete,
}: Props) {
  if (!canWrite) return null;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          type="button"
          variant="ghost"
          size="icon-sm"
          className={cn(
            "shrink-0 text-muted-foreground",
            compact
              ? "size-6 opacity-0 group-hover:opacity-100 data-[state=open]:opacity-100"
              : "size-7",
          )}
          aria-label="文件夹操作"
          onClick={(e) => e.stopPropagation()}
        >
          <MoreHorizontal className="size-3.5" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-40" onClick={(e) => e.stopPropagation()}>
        <DropdownMenuItem
          onSelect={() => {
            onRename();
          }}
        >
          <Pencil className="size-3.5" />
          重命名
        </DropdownMenuItem>
        <DropdownMenuItem
          onSelect={() => {
            onMove();
          }}
        >
          <FolderInput className="size-3.5" />
          移动到…
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuItem
          variant="destructive"
          disabled={!isEmpty}
          onSelect={() => {
            if (isEmpty) onDelete();
          }}
        >
          <Trash2 className="size-3.5" />
          删除
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
